<template>
  <section class="my-10 flex flex-col" :aria-label="$t('signin.title')">
    <h1 class="w-full text-center">
      {{ $t('signin.title') }}
    </h1>
    <div class="flex flex-col md:flex-row mt-10 md:mt-6">
      <div class="md:w-1/2 flex flex-col px-6">
        <h2
          class="uppercase bg-blackish text-white text-center">
            {{ $t('signin.register') }}
        </h2>
        <material-input class="mt-6" :name="$t('signin.firstname')" v-model="registration.firstname"
          :showMessage="errors.has('firstname')" :message="errors.get('firstname')" @clear="errors.clear('firstname')" />
        <material-input class="mt-6" :name="$t('signin.lastname')" v-model="registration.lastname"
          :showMessage="errors.has('lastname')" :message="errors.get('lastname')" @clear="errors.clear('lastname')" />
        <material-input class="mt-6" :name="$t('signin.email')" v-model="registration.email"
          :showMessage="errors.has('email')" :message="errors.get('email')" @clear="errors.clear('email')" />
        <material-input class="mt-6" :name="$t('signin.password')" :type="'password'" v-model="registration.password"
          :showMessage="errors.has('password')" :message="errors.get('password')" @clear="errors.clear('password')" />
        <material-input class="mt-6" :name="$t('signin.confirmPassword')" :type="'password'"
          v-model="registration.password_confirmation" @clear="emptyConfirmation = false"
          :showMessage="emptyConfirmation" />
        <button
          class="mt-6 bg-redish text-white uppercase font-bold py-2 tracking-wide cursor-pointer"
          @click="registerIn"
          :class="isLoading ? 'loader' : ''"
        >
          {{ $t('signin.register') }}
        </button>
        <span class="text-sm mt-4">{{ $t('signin.vatsMessage') }} <strong>{{ shop.email }}</strong></span>
      </div>
      <div class="md:w-1/2 mt-24 md:mt-0 mb-20 md:mb-0 flex flex-col px-6">
        <h2
          class="uppercase bg-blackish text-white text-center">
          {{ $t('signin.login') }}
        </h2>
        <material-input class="mt-6" :name="$t('signin.email')" id="email-signin" v-model="credentials.email" />
        <material-input class="mt-6" :name="$t('signin.password')" id="password-signin" :type="'password'" v-model="credentials.password" />
        <button
          class="mt-6 bg-redish text-white uppercase font-bold py-2 tracking-wide cursor-pointer"
          @click="login"
        >
          {{ $t('signin.login') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import MaterialInput from '@/components/blocks/MaterialInput.vue';
import Errors from '@/util/Errors';

import { mapActions, mapGetters } from 'vuex';

export default {

  components: { MaterialInput },

  data() {
    return {
      credentials: {
        email: '',
        password: '',
      },

      registration: {
        name: '',
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        password_confirmation: '',
      },

      emptyConfirmation: false,

      errors: new Errors(),

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      shop: 'shop',
    }),
  },

  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
      register: 'auth/register',
    }),
    login() {
      this.signIn(this.credentials)
        .then(() => {
          this.createNotification('success', `${this.$t('notifications.successfulLogin')}`);
          // this.$router.push('/profile');
          this.$router.push(this.$route.query.redirect || '/profile');
        }).catch(() => {
          this.createNotification('error', `${this.$t('notifications.credentialsInvalid')}`);
        });
    },

    registerIn() {
      if (this.registration.password_confirmation === '') {
        this.emptyConfirmation = true;
      }
      this.isLoading = true;
      this.registration.name = `${this.registration.firstname} ${this.registration.lastname}`;
      const redirectPath = this.$route.query.redirect;
      this.register(this.registration)
        .then(() => {
          this.createNotification('success', `${this.$t('notifications.registration')}`);
          this.$router.push({ path: '/verify', query: { redirect: redirectPath } });
          this.isLoading = false;
        }).catch((errors) => {
          this.isLoading = false;
          this.errors.record(errors.response.data.errors);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
